<template>
  <div
    v-if="ctas?.children?.length"
    :class="['ctas-cont', ctas?.attributes?.linkLayout]"
  >
    <template
      v-for="(link, index) in ctas?.children"
      :key="index"
    >
      <a
        :class="ctasClass"
        :href="link?.url"
        :alt="link?.alt"
        @click="() => fireLinkTag(link)"
      >{{ link?.text }}
      </a>
    </template>
  </div>
</template>

<script setup>
import { fireTag } from '@vue-util/tagManager';

const props = defineProps({
  ctas: {
    type: Object,
    default: () => {},
  },
  alignment: {
    type: String,
    default: 'left',
  },
  linkClass: {
    type: String,
    default: 'link-med',
  },
});

const ctaAlignMap = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center',
};
const ctaAlign = ctaAlignMap[props?.alignment] || 'flex-start';

const linkStyle = {
  primaryButton: 'primary button',
  secondaryButton: 'secondary button',
  underlinedText: 'link-med',
};

const ctasClass = [props?.alignment, linkStyle[props.ctas?.attributes?.linkStyle] || props?.linkClass];

const stackDir = props.ctas?.attributes?.linkLayout === 'vertical' ? 'column' : 'row';

const fireLinkTag = (cta) => {
  if (cta.assetAnalytics) {
    const data = {
      event_name: 'content link click',
      asset_analytics: cta.assetAnalytics,
    };
    if (cta.analytics) {
      data.impression_data = cta.analytics;
    }
    fireTag('link', data);
  }
};
</script>

<style lang="scss" scoped>
@import "~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss";
.ctas-cont {
  display: flex;
  flex-direction: v-bind(stackDir);
  flex-wrap: wrap;
  margin-top: rem-calc(16);
  &.horizontal {
    justify-content: v-bind(ctaAlign);
    row-gap: rem-calc(16px);
    a {
      margin-right: rem-calc(24px);

      &.primary,
      &.secondary {
        margin-right: rem-calc(16px);
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    a.left {
      margin-right: rem-calc(24px);
      margin-left:0;

      &.primary,
      &.secondary {
        margin-right: rem-calc(16px);
      }
    }
    a.right {
      margin-left: rem-calc(24px);
      margin-right:0;

      &.primary,
      &.secondary {
        margin-left: rem-calc(16px);
      }
    }
    a.center{
      margin-left: rem-calc(12px);
      margin-right: rem-calc(12px);
    }
  }
  &.vertical {
    align-items: v-bind(ctaAlign);
    a {
      margin-top: rem-calc(16);
      @include breakpoint(small down){
        margin-top: rem-calc(24);
      }
      &.primary,
      &.secondary {
        margin-top: rem-calc(16);
      }
      &:first-child {
        margin-top: 0;
      }
    }
    a.center{
      margin-left: rem-calc(12px);
      margin-right: rem-calc(12px);
    }
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
.ctas-cont {
  margin-top: rem-calc(32);
  @include breakpoint(medium down){
    margin-top: rem-calc(16);
  }
}
</style>
